import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY_DEPTH   = 'copilotDepth';
const STORAGE_KEY_MODE    = 'copilotMode';

export type CopilotDepth = 0 | 1 | 2;
export type CopilotMode  = 'builder' | 'advisor' | 'autonomous';

@Injectable({ providedIn: 'root' })
export class CopilotSettingsService {
  private readonly _depth$ = new BehaviorSubject<CopilotDepth>(this._loadDepth());
  private readonly _mode$  = new BehaviorSubject<CopilotMode>(this._loadMode());

  readonly depth$ = this._depth$.asObservable();
  readonly mode$  = this._mode$.asObservable();

  get depth(): CopilotDepth { return this._depth$.getValue(); }
  get mode(): CopilotMode   { return this._mode$.getValue();  }

  setDepth(value: CopilotDepth): void {
    localStorage.setItem(STORAGE_KEY_DEPTH, JSON.stringify(value));
    this._depth$.next(value);
  }

  setMode(value: CopilotMode): void {
    localStorage.setItem(STORAGE_KEY_MODE, value);
    this._mode$.next(value);
  }

  private _loadDepth(): CopilotDepth {
    const stored = localStorage.getItem(STORAGE_KEY_DEPTH);
    if (stored !== null) {
      const v = JSON.parse(stored);
      if (v === 0 || v === 1 || v === 2) return v;
    }
    // Migrate legacy boolean deepDive setting
    const legacy = localStorage.getItem('copilotDeepDive');
    return (legacy === 'true') ? 1 : 0;
  }

  private _loadMode(): CopilotMode {
    const stored = localStorage.getItem(STORAGE_KEY_MODE);
    if (stored === 'builder' || stored === 'advisor' || stored === 'autonomous') return stored;
    return 'builder';
  }

}
